import * as SikoNewsActions from './news-group.actions';

export { SikoNewsActions };
